import Vue from 'vue';
const { MethodType, promiseRequest } = require('./promise');
const AppId = '70076467277E4B1DD42F21B4DB5BD5A7';
const { Md5, Sha } = require('../../lib/paramsMach');

let retParamDate = '';
retParamDate = async(_url, Type = MethodType.POST, data = {}, domain, config) => {
    let loadingLoader = null
    if (data['loadingLoader']) {
        loadingLoader = data['loadingLoader']
        delete data['loadingLoader']
    }

    let paramData = {
        AppId,
        language: window.localStorage.getItem('lang') == 'en' ? 'en' : 'zh',
        TimeStamp: new Date().getTime(),
        data,
        v: '2.6'
    };

    let latestParam = Md5.paramsMach(paramData)
    let res = await promiseRequest(_url, Type, latestParam, domain, loadingLoader, config);
    if (res.data.info == '操作成功') {
        res.data.info = window.localStorage.getItem('lang') == 'en' ? 'Operation succeeded' : '操作成功'
    }
    if (res.data.code == 1000 || res.data.code == 1001) {
        console.log(data)
        let data = {
            "cmd": 'close',
            "param": {}
        }
        console.log(data)
        try {
            window.webkit.messageHandlers.bridgeCmd.postMessage(data)
        } catch (e) {
            console.log(e)
        }
        try {
            helper.bridgeCmd(JSON.stringify(data))
        } catch (e) {
            console.log(e)
        }
    }

    return res
}

export default {
    // _getWalletDownload: async (param) => {
    //   let ret = await promiseRequest(`/public/versions/latest`, MethodType.GET, param, 'M2');

    //   return ret.data ? ret.data : {}
    // },
    // // 检验手机号码
    // _verifyPhoneAndEmailExists: async (param) => {
    //   let ret = await retParamDate('/account/verifyPhoneAndEmailExists', MethodType.post, param, 'M1')

    //   return ret.data ? ret.data : {}
    // },  
    // 首页信息
    _sejGoods: async(param) => {
        let ret = await retParamDate('/goods', MethodType.post, param, 'M2')

        return ret.data ? ret.data : {}
    },
    _retRequest: async(url, methodType, param, config = {}, domainItem = 'M2') => {
        let ret = await retParamDate(url, MethodType[methodType], param, domainItem, config)

        return ret.data ? ret.data : {}
    },

}


// WEBPACK FOOTER //
// ./src/utils/api.js